import React, { useState } from 'react';

export const DeviceModal = ({ isOpen, onClose, onSubmit }) => {
	const [name, setName] = useState('');

	const handleSubmit = async () => {
		if (!name) {
			alert('Введите название устройства');
			return;
		}

		onSubmit(name);
	};

	if (!isOpen) return null;

	return (
		<div style={modalStyles}>
			<div style={modalContentStyles}>
				<input
					type="text"
					value={name}
					onChange={(e) => setName(e.target.value)}
					placeholder="Название устройства"
					style={inputStyles}
				/>

				<div style={buttonContainerStyles}>
					<button onClick={handleSubmit} style={buttonStyles}>
						Добавить
					</button>
					<button onClick={onClose} style={buttonStyles}>
						Закрыть
					</button>
				</div>
			</div>
		</div>
	);
};

// Стили
const modalStyles = {
	position: 'fixed',
	top: 0,
	left: 0,
	width: '100%',
	height: '100%',
	backgroundColor: 'rgba(0, 0, 0, 0.5)',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	zIndex: 1000,
};

const modalContentStyles = {
	backgroundColor: 'white',
	padding: '20px',
	borderRadius: '8px',
	width: '400px',
	maxHeight: '90%',
	overflowY: 'auto',
	textAlign: 'center',
};

const inputStyles = {
	width: '100%',
	padding: '10px',
	margin: '5px 0',
	borderRadius: '5px',
	border: '1px solid #ccc',
};

const buttonContainerStyles = {
	display: 'flex',
	justifyContent: 'space-between',
	marginTop: '10px',
};

const buttonStyles = {
	padding: '10px',
	borderRadius: '5px',
	border: '1px solid #ccc',
	cursor: 'pointer',
};
